export const getModalByStatus = (statusCode: string, MODAL_COMPONENTS: any) => {
  if (
    statusCode === "0000" ||
    statusCode === "0012" ||
    statusCode === "SUCCESS"
  ) {
    return MODAL_COMPONENTS.SUCCESS;
  } else {
    return MODAL_COMPONENTS.FAILED;
  }
};
